import { render, staticRenderFns } from "./Customertemplate.vue?vue&type=template&id=c02b5668&"
import script from "./Customertemplate.vue?vue&type=script&lang=js&"
export * from "./Customertemplate.vue?vue&type=script&lang=js&"
import style0 from "./Customertemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports